import api from "@/helpers/api";
import type { WidgetConfig } from "../types/widget";

export const getWidgetConfig = async () => {
  const response = await api.get({ path: "/widgets" });
  return response;
};


export const saveWidgetConfig = async (config: WidgetConfig) => {
  const response = await api.post({ path: "/widgets", data: config });
  return response;
};

export const updateBanner = async (bannerId: string, data: Record<string, any>) => {
  const response = await api.post({
    path: "/widgets/banners",
    data: {
      banner_id: bannerId,
      data: data
    }
  });
  return response;
};

// Helper function for dismissing a banner (commonly used)
export const dismissBanner = async (bannerId: string) => {
  return updateBanner(bannerId, {
    status: false // Hide the banner
  });
};

